export default __webpack_public_path__ + "assets/models/e60982a522f26dcf25abb8621163242c.glb";